import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Nav } from '../components/Nav';
import { PageGuides } from '../components/PageGuides';
import { Hero } from '../components/Hero';
import { IntroStatement } from '../components/IntroStatement';
import { LogoWall } from '../components/LogoWall';
import { ServicesAccordion } from '../components/ServicesAccordion';
import { Statement } from '../components/Statement';
import { Work } from '../components/Work';
import { Reviews } from '../components/Reviews';
import { SiteIndex } from '../components/SiteIndex';
import { Engagements } from '../components/Engagements';
import { Awards } from '../components/Awards';
import { Journal } from '../components/Journal';
import { Faq } from '../components/Faq';
import { Footer } from '../components/Footer';
import { useTwoLineSerif } from '../hooks/useTwoLineSerif';

// Overrides the page's colour tokens for the dark bands (projects, testimonials + awards)
const darkBandTheme = {
  '--bg-rgb': '14 14 14',
  '--fg-rgb': '245 245 242',
  '--surface-rgb': '24 24 24',
  '--line': 'rgba(255, 255, 255, 0.12)',
  '--muted': '#8a8a8a',
  colorScheme: 'dark'
} as React.CSSProperties;
export function Home() {
  useTwoLineSerif();
  const {
    hash
  } = useLocation();

  // Arriving from a subpage with a section link (e.g. "/#work"): scroll to that section
  useEffect(() => {
    document.title = 'LAEBEL — Single source of origin';
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const t = window.setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo(0, y);
      }
    }, 60);
    return () => window.clearTimeout(t);
  }, [hash]);
  return <main className="min-h-screen w-full bg-bg text-fg" data-id="element-521" data-mp="1z7ftq197hrud">
      <PageGuides data-id="element-522" data-mp="1z6wfovmofnlm" />
      <Nav data-id="element-523" data-mp="1z9inmwdhc54d" />
      <Hero data-id="element-524" data-mp="1u8cpgj11vpng" />
      <IntroStatement data-id="element-525" data-mp="1u8l5ukwdtd3e" />
      <LogoWall data-id="element-526" data-mp="1u9e1appw4g68" />
      <ServicesAccordion data-id="element-527" data-mp="1u8uvu8hffk93" />
      {/* Projects band: dark, behind the About statement + projects */}
      <div style={darkBandTheme} className="bg-bg text-fg" data-id="element-528" data-mp="1kj5snpu82vgm">
        <Statement data-id="element-529" data-mp="1omu1scyi5z3z" />
        <Work data-id="element-530" data-mp="1ondgzlwrq9eb" />
      </div>
      <SiteIndex data-id="element-531" data-mp="1onncfp0l18re" />
      <Reviews data-id="element-532" data-mp="1ojzhclfhoeak" />
      <div style={darkBandTheme} className="bg-bg pt-20 text-fg md:pt-28" data-id="element-533" data-mp="1amsyyryoghlv">
        <Awards data-id="element-534" data-mp="1aonji561e7pf" />
      </div>
      <Engagements data-id="element-535" data-mp="1fle4n6wp7thp" />
      {/* Dark news band */}
      <div style={darkBandTheme} className="bg-bg pt-20 text-fg md:pt-28" data-id="element-536" data-mp="1flw6cj24qzx0">
        <Journal data-id="element-537" data-mp="23c9ptl6nfqfz" />
      </div>
      {/* Near-white FAQ band */}
      <div className="bg-[#fbfbf9] pt-20 md:pt-28" data-id="element-538" data-mp="28a1sna8u0wyy">
        <Faq data-id="element-539" data-mp="289s2nmnsept9" />
      </div>
      <Footer data-id="element-540" data-mp="28c4gpoqfcg11" />
    </main>;
}